import React from 'react';
import { motion } from 'framer-motion';

const ESTATE_ANIMATION_VARIANTS = {
  estateIn: {},
  estateOut: {
    marginLeft: 'calc(-100% - -100px)',
  },

  outEstateIn: {
    marginLeft: '-100px',
  },
  outEstateOut: { marginLeft: '-100px' },
};

interface Props {
  children: React.ReactNode;
  isLeftSideElement?: boolean;
  isInitialPosition: boolean;
}

export const AnimationParent = ({ children, isLeftSideElement, isInitialPosition }: Props) => {
  return (
    <motion.section
      {...(isLeftSideElement
        ? { animate: isInitialPosition ? 'estateIn' : 'estateOut' }
        : { animate: isInitialPosition ? 'outEstateIn' : 'outEstateOut' })}
      variants={ESTATE_ANIMATION_VARIANTS}
      transition={{ type: 'tween' }}
      style={{
        display: 'flex',
        minWidth: '100%',
        justifyContent: isLeftSideElement
          ? isInitialPosition
            ? 'center'
            : 'flex-end'
          : isInitialPosition
          ? 'flex-start'
          : 'center',
      }}
    >
      {children}
    </motion.section>
  );
};
